import { FLYBITS } from '../constants';
import { IUser } from '../types/authentication';
import axios from '../utils/axios';

export const me = async (token: string): Promise<IUser | undefined> => {
    const endpoint = FLYBITS.FLYBITS_PROXY_HOST + '/sso/auth/me';
    let user;
    const response = (await axios.get(endpoint, {
        headers: {
            Authorization: token
        },
        validateStatus: (status: number) => true
    }));
    if (200 === response.status) {
        user = response.data
    }
    return user;
}





// WEBPACK FOOTER //
// ./src/services/demo.ts